import httpService from "./httpService";

export default {

  findByDocIdAndRelationType(docId, relationType) {
    return httpService.get("/vbDocUser/findByDocIdAndRelationType", {
      params: {docId, relationType}
    });
  },

  markAsDaXLForBcc(id) {
    return httpService.put(`/vbDocUser/${id}/markAsDaXLForBcc`);
  },

  findByVbIncomingProcessId(processId) {
    return httpService.get("/vbDocUser/findByVbIncomingProcessId", {
      params: {processId}
    });
  },
};



// WEBPACK FOOTER //
// ./src/services/vbDocUserService.js